exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".canvas-container{text-align:center}.board-canvas{border:1px solid #000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./styles/modules/boardCanvas.scss
// module id = 299
// module chunks = 0